import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "./components/NetworkGraph";
import Reveal from "./components/Reveal";
import { IconMail, IconMapPin, IconClock, IconLock, IconCheck } from "./components/Icons";

const SUBJECTS = [
  "Gestão de TI (MSP)",
  "RMM / Gestão de Endpoints",
  "Suporte Técnico",
  "Consultoria & Projetos",
  "sepolHOSTING — Hospedagem",
  "sepolDRIVE — Nuvem Privada",
  "sepolBACKUP — Backup",
  "sepolCHAT — Atendimento",
  "sepolSECURITY — Segurança",
  "ERP Bruning",
  "Outro",
];

const INITIAL_FORM = {
  nome: "",
  empresa: "",
  email: "",
  telefone: "",
  assunto: "",
  mensagem: "",
};

const CONTACT_INFO = [
  {
    Icon: IconMail,
    title: "E-mail",
    content: (
      <a href="mailto:contato@sepoltech.com.br" style={{ color: "var(--text-secondary)", fontSize: "15px" }}>
        contato@sepoltech.com.br
      </a>
    ),
  },
  {
    Icon: IconMapPin,
    title: "Localização",
    content: <div style={{ color: "var(--text-secondary)", fontSize: "15px" }}>Rua Vergueiro, 6455 - Alto do Ipiranga, São Paulo - SP</div>,
  },
  {
    Icon: IconClock,
    title: "Horário de atendimento",
    content: (
      <div style={{ color: "var(--text-secondary)", fontSize: "15px" }}>
        Segunda a Sexta, 8h30 às 17h30
      </div>
    ),
  },
];

export default function Contato() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitted, setSubmitted] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setEnviando(true);

    try {
      const res = await fetch("/api/contato.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();

      if (data.ok) {
        setSubmitted(true);
        setForm(INITIAL_FORM);
      } else {
        setErro(data.erro || "Não foi possível enviar sua mensagem.");
      }
    } catch {
      setErro("Erro de conexão. Verifique sua internet e tente novamente.");
    } finally {
      setEnviando(false);
    }
  };
  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <span>Contato</span>
          </div>
          <div className="tag animate-up animate-up--d1">Fale Conosco</div>
          <h1
            className="section-title animate-up animate-up--d2"
            style={{ fontSize: "clamp(32px,5vw,52px)", maxWidth: "600px" }}
          >
            Vamos conversar sobre
            <br />
            <span className="text-blue">a TI da sua empresa?</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "17px",
              color: "var(--text-secondary)",
              maxWidth: "520px",
              lineHeight: "1.7",
              marginTop: "16px",
            }}
          >
            Preencha o formulário e nossa equipe entra em contato em até 1
            dia útil. Sem compromisso, sem enrolação.
          </p>
        </div>
      </section>

      {/* ═══════════════ INFO + FORMULÁRIO ═══════════════ */}
      <section className="section">
        <div className="container">
          <div className="grid-2col-asym">
            {/* Info */}
            <Reveal>
              <h2
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "22px",
                  fontWeight: 700,
                  marginBottom: "32px",
                  color: "var(--text-primary)",
                }}
              >
                Informações de contato
              </h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  marginBottom: "40px",
                }}
              >
                {CONTACT_INFO.map((info) => (
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }} key={info.title}>
                    <div
                      style={{
                        width: "44px",
                        height: "44px",
                        background: "var(--brand-blue-glow)",
                        borderRadius: "var(--radius-sm)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "var(--brand-blue)",
                        flexShrink: 0,
                      }}
                    >
                      <info.Icon style={{ width: "20px", height: "20px" }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, marginBottom: "4px", color: "var(--text-primary)" }}>
                        {info.title}
                      </div>
                      {info.content}
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  background: "var(--bg-card)",
                  border: "1px solid var(--bg-border)",
                  borderRadius: "var(--radius-lg)",
                  padding: "24px",
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: "8px", color: "var(--text-primary)" }}>
                  Já é cliente?
                </div>
                <p
                  style={{
                    fontSize: "14px",
                    color: "var(--text-muted)",
                    marginBottom: "16px",
                    lineHeight: "1.6",
                  }}
                >
                  Para suporte técnico, acesse a área do cliente e abra um
                  chamado.
                </p>
                <Link
                  to="/login"
                  className="btn btn-outline"
                  style={{ width: "100%", justifyContent: "center", gap: "8px" }}
                >
                  <IconLock style={{ width: "15px", height: "15px" }} />
                  Área do Cliente →
                </Link>
              </div>
            </Reveal>

            {/* Formulário */}
            <Reveal delay={0.1} className="card" style={{ padding: "40px" }}>
              {submitted ? (
                <div style={{ textAlign: "center", padding: "32px 0" }}>
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      background: "rgba(34,197,94,.15)",
                      color: "var(--success)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                    }}
                  >
                    <IconCheck style={{ width: "28px", height: "28px" }} />
                  </div>
                  <h3
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "20px",
                      fontWeight: 700,
                      marginBottom: "8px",
                      color: "var(--text-primary)",
                    }}
                  >
                    Mensagem enviada!
                  </h3>
                  <p style={{ color: "var(--text-muted)", fontSize: "15px" }}>
                    Nossa equipe entrará em contato em breve.
                  </p>
                </div>
              ) : (
                <>
                  <h3
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "20px",
                      fontWeight: 700,
                      marginBottom: "28px",
                      color: "var(--text-primary)",
                    }}
                  >
                    Solicitar contato
                  </h3>
                  <form className="contact-form" onSubmit={handleSubmit}>
                    {erro && (
                      <div
                        style={{
                          background: "rgba(239,68,68,.1)",
                          border: "1px solid rgba(239,68,68,.3)",
                          color: "var(--error)",
                          padding: "12px 16px",
                          borderRadius: "8px",
                          fontSize: "14px",
                        }}
                      >
                        {erro}
                      </div>
                    )}
                    <div className="form-row">
                      <div className="form-group">
                        <label>Nome *</label>
                        <input
                          type="text"
                          name="nome"
                          placeholder="Seu nome completo"
                          value={form.nome}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Empresa</label>
                        <input
                          type="text"
                          name="empresa"
                          placeholder="Nome da empresa"
                          value={form.empresa}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>E-mail *</label>
                        <input
                          type="email"
                          name="email"
                          placeholder="seu@email.com.br"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Telefone / WhatsApp</label>
                        <input
                          type="tel"
                          name="telefone"
                          placeholder="(11) 99999-9999"
                          value={form.telefone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Assunto</label>
                      <select name="assunto" value={form.assunto} onChange={handleChange}>
                        <option value="">Selecione um assunto</option>
                        {SUBJECTS.map((subject) => (
                          <option key={subject} value={subject}>
                            {subject}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Mensagem *</label>
                      <textarea
                        name="mensagem"
                        placeholder="Conte um pouco sobre a sua empresa e o que você precisa..."
                        value={form.mensagem}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={enviando}
                      style={{ width: "100%", justifyContent: "center", padding: "16px", opacity: enviando ? 0.7 : 1 }}
                    >
                      {enviando ? "Enviando..." : "Enviar mensagem →"}
                    </button>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "var(--text-muted)",
                        textAlign: "center",
                      }}
                    >
                      Respondemos em até 1 dia útil. Seus dados são tratados
                      com sigilo.
                    </p>
                  </form>
                </>
              )}
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
